/* Copyright CloudLinux Zug GmbH 2010-2017 All Rights Reserved
 *
 * Licensed under CLOUD LINUX LICENSE AGREEMENT
 * http://cloudlinux.com/docs/LICENSE.TXT
 */

import { Component } from '@angular/core';
import {BaseComponent} from "./utils/base_component";
import {SafeHtml} from "@angular/platform-browser";
import {AppState} from "./app.service";


@Component({
    template: require('./../templates/unavailable.component.html'),
    styles: [require('../styles/unavailable.component.less')],
})
export class UnavailableComponent extends BaseComponent {
    public errorText: SafeHtml;
    public errorContext: {};
    public icon: string = 'info';

    constructor (public appState: AppState) {
        super();
    }

    back() {
        window.history.go(-this.appState.get('historyLength'));
    }
}



// WEBPACK FOOTER //
// node_modules/angular2-template-loader!./node_modules/angular-router-loader/src?loader=system&genDir=compiled&aot=false!./src/app/unavailable.component.ts